<span
    class="dropdown-divider"
    role="separator"
    aria-hidden="true">
</span>